'use client';

import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import Card from '@classify/react-core-components/Card';
import LearningOutcome from './LearningOutcome';
import CourseProgress from './CourseProgress';
import ProgressionIllustration from './ProgressionIllustration';
type Props = {
  progression?: number;
  learningOutcomes?: {
    status: string;
  }[];
  isLoadingLearningOutcomes?: boolean;
};
export default function CourseInProgressCard(t0) {
  const $ = _c(20);
  const {
    progression: t1,
    learningOutcomes,
    isLoadingLearningOutcomes
  } = t0;
  const progression = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== learningOutcomes) {
    t2 = learningOutcomes || [];
    $[0] = learningOutcomes;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = t2.filter(_temp);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const passedOutcomes = t3;
  const shouldShowLearningOutcomes = isLoadingLearningOutcomes || !isLoadingLearningOutcomes && (learningOutcomes?.length || 0) > 0;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      p: 4,
      overflow: "visible"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== progression) {
    t5 = <div><CourseProgress progression={progression} /></div>;
    $[5] = progression;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== learningOutcomes?.length || $[8] !== passedOutcomes || $[9] !== shouldShowLearningOutcomes) {
    t6 = shouldShowLearningOutcomes && <Box sx={{
      pt: 2,
      borderTop: "1px solid",
      borderColor: "stroke"
    }}><LearningOutcome value={passedOutcomes.length} max={learningOutcomes?.length || 100} /></Box>;
    $[7] = learningOutcomes?.length;
    $[8] = passedOutcomes;
    $[9] = shouldShowLearningOutcomes;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <Stack gap={2}>{t5}{t6}</Stack>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      mr: -8,
      mb: -8,
      alignSelf: "flex-end"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== progression) {
    t9 = <Box sx={t8}><ProgressionIllustration progression={progression} /></Box>;
    $[15] = progression;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <Card sx={t4}><Stack direction="row" gap={1}>{t7}{t9}</Stack></Card>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
function _temp(outcome) {
  return outcome.status === "passed";
}